module.exports = __webpack_public_path__ + "static/images/hieroglyphics-initiative.eb8def226c20e8add8462075844b309c.jpg";